<template>
  <el-container>
    <el-main v-if="tutors">
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="8">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Create Tutor</h4>
            </div>
            <div class="card-content">
              <el-form :model="tutor" :rules="rules" ref="tutor" label-width="120px" class>
                <el-form-item label="Firstname" prop="firstname">
                  <el-input v-model="tutor.firstname"></el-input>
                </el-form-item>
                <el-form-item label="Lastname" prop="lastname">
                  <el-input v-model="tutor.lastname"></el-input>
                </el-form-item>
                <el-form-item label="Address" prop="address.line1">
                  <el-input v-model="tutor.address.data.line1"></el-input>
                </el-form-item>
                <el-form-item label prop="address.line2">
                  <el-input v-model="tutor.address.data.line2"></el-input>
                </el-form-item>
                <el-form-item label="Town" prop="address.town">
                  <el-input v-model="tutor.address.data.town"></el-input>
                </el-form-item>
                <el-form-item label="Post Code" prop="address.postcode">
                  <el-input v-model="tutor.address.data.postcode"></el-input>
                </el-form-item>
                <el-form-item label="Country" prop="address.country">
                  <el-select v-model="tutor.address.data.country" placeholder="Country">
                    <el-option
                      v-for="(country,index) in countries"
                      class="select-default"
                      :value="country"
                      :label="index"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Email" prop="email" size="mini">
                  <el-input v-model="tutor.email"></el-input>
                </el-form-item>
                <el-form-item label="Phone" prop="address.phone" size="mini">
                  <el-input v-model="tutor.address.data.phone"></el-input>
                </el-form-item>
                <el-form-item label="Active">
                  <el-checkbox v-model="checked"></el-checkbox>
                </el-form-item>
                <el-form-item label="Currency" prop="currency">
                  <el-select v-model="tutor.currency" placeholder="Select">
                    <el-option
                      v-for="currency in currencies"
                      class="select-default"
                      :value="currency"
                      :label="currency"
                      :key="currency"
                      ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="createTutor('tutor')">Create</el-button>
                  <el-button @click="resetForm('tutor')">Reset</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Tutors List</h4>
            </div>
            <div class="card-content">

              <el-row style="margin-top:30px; margin-bottom: 10px">

                <el-col :span="7">
                  <label class="control-label">Is active:</label><br>
                  <el-select
                    v-model="filters[0].value"
                    size="mini"
                    class="form-group border-input"
                    placeholder="Select Status"
                    @change="getTutors"
                  >
                    <el-option label="Any status" value="2"></el-option>
                    <el-option label="Only Active" value="1"></el-option>
                    <el-option label="Only Inactive" value="0"></el-option>
                  </el-select>
                </el-col>
                
              </el-row>

              <data-tables-server 
              class="table-shopping" 
              style="width: 100%" 
              :data="tutors" 
              :tool-bar="false" 
              :current-page="1" 
              :total="total"
              :loading="loadingTutors"
              :page-size="20"
              @query-change="getTutors"
              :filters="filters"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                <el-table-column label="Name" min-width="35" sortable="custom" prop="lastname">
                  <template slot-scope="props">{{props.row.firstname}} {{props.row.lastname}}</template>
                </el-table-column>

                <el-table-column label="Email" min-width="35">
                  <template slot-scope="props">{{props.row.email}}</template>
                </el-table-column>

                <el-table-column label="Rating" min-width="10" sortable="custom" prop="rating">
                  <template slot-scope="props">{{props.row.rating}}</template>
                </el-table-column>

                <el-table-column label="Active" min-width="10" sortable="custom" prop="isActive">
                  <template slot-scope="props">
                      <small class="label label-danger" v-if="props.row.isActive === 0"><i class="fa fa-times"></i> No</small>
                      <small class="label label-success" v-if="props.row.isActive === 1"><i class="fa fa-check"></i> Yes</small>
                  </template>
                </el-table-column>

                <el-table-column min-width="10" label="Edit" class="td-text">
                  <template slot-scope="props">
                    <router-link :to="'/tutors/edit/' +props.row.id">Edit</router-link>
                  </template>
                </el-table-column>
              </data-tables-server>
                  
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
import json from "../../data/countries.json";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
      loadingTutors:false,
      total:0,
      checked: true,
      tutors: [],
      currencies: ["GBP", "EUR", "USD"],
      filters: [
        {
          value: "1",
          prop: "isActive",
        }, 
        {
          value: "80",
          prop: "rating"
        }
      ],
      tutor: {
        address:{
          data: {
            line1: '',
            line2: '',
            country: '',
            town: '',
            phone: ''
          }
        },
        canLogin: "1",
        isActive: "1",
        rating: "0",
        dateUpdated: moment().format(),
        dateCreated: moment().format()
      },
      countries: json,
      ///for pagination
      listQuery: {
        filterBy: "id",
        page: 0,
        limit: 20,
        skip: 0,
        orderBy: "lastname",
        orderDirection: "DESC"
      },
      // for validation
      rules: {
        firstname: [
          { required: true, message: "Please input name", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "Length should be 3 to 5",
            trigger: "blur"
          }
        ],
          lastname: [
          { required: true, message: "Please input name", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "Length should be 3 to 5",
            trigger: "blur"
          }
        ],
        address1: [
          { required: true, message: "Please add address", trigger: "change" }
        ],
        town: [
          { required: true, message: "Please add town", trigger: "change" }
        ],
        country: [
          { required: true, message: "Please add country", trigger: "change" }
        ],
        email: [
          {
            type: "email",
            required: false,
            message: "Please input correct email address",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    async getTutors(queryInfo) {

      if ( queryInfo != undefined ) {

        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = 'asc_nulls_last';
        var orderProp = 'id';

        (queryInfo.type === 'page' || queryInfo.type === 'size' || queryInfo.type === 'sort') //&&
        //this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`)

        
        if (queryInfo.sort.order === 'ascending') {
          orderDir = 'asc_nulls_last';
        } else if (queryInfo.sort.order === 'descending') {
          orderDir = 'desc_nulls_last';
        } else {}
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }

      } else {

        var type = 'init';
        var page = 1;
        var pageSize = 20;
        var orderDir = 'asc_nulls_last';
        var orderProp = 'id';

      }

      var equalStatus = this.filters[0].value === "2" ? "_lte" : "_eq"
      var equalTown = this.filters[1].value === "All" ? "_neq" : "_eq"

      this.loadingTutors = true;

      this.$apollo
      .query({
        query: gql`
        {
          Tutor(
            limit: ${pageSize}, 
            offset: ${(page - 1) * pageSize}, 
            order_by: {${orderProp}: ${orderDir}},
            where: {isActive: {${equalStatus}: ${this.filters[0].value}}}
          ) {
            id
            firstname
            lastname
            currency
            email
            rating
            isActive
            address {
              id
              line1
              line2
              country
              town
              phone
            }
          }
          Tutor_aggregate (
            where: {isActive: {${equalStatus}: ${this.filters[0].value}}}
          )
          {
            aggregate {
              count
            }
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.tutors = response.data.Tutor;
        //this.checked = !!this.tutors.historic;
        this.total = response.data.Tutor_aggregate.aggregate.count;
        this.loadingTutors = false;
      });
    },
    createTutor(formName) {
       this.$refs[formName].validate(valid => {
        if (valid) {
          const q = gql`
            mutation insert_tutor(
              $firstname: String,
              $lastname: String,
              $address: Core_Address_obj_rel_insert_input,
              $email: String,
              $currency: String,
              $canLogin: smallint,
              $isActive: smallint,
              $rating: float8,
              $dateUpdated: timestamp,
              $dateCreated: timestamp
            ) {
              insert_Tutor(objects: {
                firstname: $firstname,
                lastname: $lastname,
                email: $email,
                canLogin: $canLogin,
                currency: $currency,
                isActive: $isActive,
                rating: $rating,
                address: $address,
                dateUpdated: $dateUpdated,
                dateCreated: $dateCreated
              }) {
                affected_rows
                returning {
                  id
                  firstname
                  lastname
                  email
                }
              }
            }
          `

          this.$apollo
          
          .mutate({
            mutation: q,
            variables: {
              firstname: this.tutor.firstname,
              lastname: this.tutor.lastname,
              email: this.tutor.email,
              canLogin: this.tutor.canLogin,
              currency: this.tutor.currency,
              isActive: this.checked ? 1 : 0,
              rating: this.tutor.rating,
              dateUpdated: this.tutor.dateUpdated,
              dateCreated: this.tutor.dateCreated,
              address: {
                data: {
                  line1: this.tutor.address.data.line1,
                  line2: this.tutor.address.data.line2,
                  town: this.tutor.address.data.town,
                  postcode: this.tutor.address.data.postcode,
                  country: this.tutor.address.data.country,
                  phone: this.tutor.address.data.phone
                }
              }
            }
          })

          .then(result => {
            this.$notify({
              title: "Create new tutor",
              message: "New tutor created",
              type: "success"
            })
          })
          .catch(error => {
            this.$notify({
              title: "Error message",
              message: error.message,
              type: "error"
            })
          })
        }else{

           this.$notify({
            title: "Error Creating Tutor",
            message: "Please check you have filled in the correct items",
            duration: 0,
            type:'error'
          });
          return false;
        }
       });
    },
    sortChange(data) {
      if (data.prop) {
        this.listQuery.orderBy = data.prop;
        if (data.order == "ascending") {
          data.order = "ASC";
        } else {
          data.order = "DESC";
        }
        this.listQuery.orderDirection = data.order;
      }
      this.getTutors();
    }
  },
  mounted() {
    this.getTutors();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Classrooms/Tutors.vue